import { combineReducers } from 'redux';

import app from './app';
import cart from './cart';
import checkout from './checkout';
import promocode from './promocode';
import search from './search';
import subscribe from './subscribe';
import wishList from './wishList';
import navigation from './navigation';
import talkToUs from './talkToUs';

export default combineReducers({
    app,
    cart,
    checkout,
    promocode,
    search,
    subscribe,
    wishList,
    navigation,
    talkToUs,
});
